export default __webpack_public_path__ + "static/media/tourIcon.94bba63b.svg";